import FormattedMessage from 'I18n/components/FormattedMessage';
import { ViewName } from 'customer-data-views-management/singleView/components/ViewName';
import { useFetchSingleView } from 'customer-data-views-management/singleView/hooks/useFetchSingleView';
import { useRenderTab } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import { convertCustomerDataViewToView } from 'framework-listing-lib/internal/ViewTabs/utils/mapper';

/**
 * This is a (somewhat) copy of the ViewName component from customer-data-views-management.
 * Since our renderTab is a renderProp, teams might return null for view tabs they don't want to render a custom component. In that case, we should render the default ViewName component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function ListingLibViewName({
  objectTypeId,
  namespaceName,
  viewId
}) {
  const renderTab = useRenderTab();
  const {
    data,
    loading,
    error
  } = useFetchSingleView({
    objectTypeId,
    id: viewId,
    namespaceName
  });
  if (error) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.singleViewName.error"
    });
  }
  if (loading || !data) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.singleViewName.loading"
    });
  }
  if (!renderTab) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: data.singleViewById.name
    });
  }
  const customViewTab = renderTab(convertCustomerDataViewToView(data.singleViewById));
  if (customViewTab === null) {
    return /*#__PURE__*/_jsx(ViewName, {
      objectTypeId: objectTypeId,
      viewId: viewId,
      namespaceName: namespaceName
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: customViewTab
  });
}